export const fetchWithCache = async (
  key: string,
  url: string
): Promise<any> => {
  const { cacheDB } = await import("./cacheDB");

  const cachedData = await cacheDB.get(key);
  if (cachedData) {
    return cachedData;
  }
  const { getHeaders } = await import("../ApiHeaders/apiHeaders");
  const { default: apiClient } = await import("../../services/apiClient");
  const headers = await getHeaders();
  const response = await apiClient.get(url, { headers });

  const data = response.data?.response?.data;
  if (Array.isArray(data)) {
    await cacheDB.set(key, data);
    return data;
  }

  throw new Error("Invalid API response format.");
};
